import React from 'react'

import { linkToImage } from 'utils/ssr.utils'
import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import Image500 from '../../../images/error_pages/500.svg'

import './page-not-found.scss'

interface Props {
  hideGoBack?: boolean
  historyGoBack?: () => void
}

const PageServerError: React.FC<Props> = ({ hideGoBack, historyGoBack }) => (
  <div className='page-not-found'>
    <img src={linkToImage(Image500)} alt='404' />
    <div className='page-not-found__error-text'>{I18n.t('react.shared.error.page_server_error')}</div>

    <div className='elo-btn-container elo-btn-container--right elo-btn-container--no-margin'>
      {!hideGoBack && (
        <EloButton orange onClick={historyGoBack}>
          {/*it's actual get BACK translation */}
          {I18n.t('react.shared.elopage_home')}
        </EloButton>
      )}
      <EloButton orange onClick={() => window.location.assign('/')}>
        {/*it's actual get HOME translation */}
        {I18n.t('react.shared.error.get_back')}
      </EloButton>
    </div>
  </div>
)

export default PageServerError
